//所有接口 
var Interface = {
	AdminLogin: "/api/Admin/Login/AdminLogin", //管理员登录
	UploadImage: "/api/Admin/Home/UploadImage", //上传图片
	UploadVideo: "/api/Admin/Home/UploadVideo", //上传视频

	//用户管理
	GetUserList: "/api/Admin/System/GetUserList", //获取用户列表
	AddUser: "/api/Admin/System/AddUser", //新增管理员
	UpdataUser: "/api/Admin/System/UpdataUser", //编辑管理员
	DeleteUser: "/api/Admin/System/DeleteUser", //删除管理员
	UpdatePassWord: "/api/Admin/System/UpdatePassWord", //修改密码
	GetUserByRoleId: "/api/Admin/System/GetUserByRoleId", //根据角色id获取用户信息
	GetUserRoleList: "/api/Admin/System/GetUserRoleList", //获取用户角色列表
	SetUserRole: "/api/Admin/System/SetUserRole", //设置用户角色
	GetUserMenus: "/api/Admin/System/GetUserMenus", //获取用户菜单权限
	GetMenuList: "/api/Admin/System/GetMenuList", //获取菜单列表
	AddMenu: "/api/Admin/System/AddMenu", //新增菜单
	UpdataMenu: "/api/Admin/System/UpdataMenu", //编辑菜单
	DeleteMenu: "/api/Admin/System/DeleteMenu", //删除菜单
	GetMenuSort: "/api/Admin/System/GetMenuSort", //删除菜单
	GetMenuTreeData: "/api/Admin/System/GetMenuTreeData", //获取菜单树形数据
	GetMenuPermissionList: "/api/Admin/System/GetMenuPermissionList", //获取菜单权限数据
	UpdateMenuPermission: "/api/Admin/System/UpdateMenuPermission", //编辑菜单权限
	SetRoleMenu: "/api/Admin/System/SetRoleMenu", //设置角色菜单权限
	GetRoleList: "/api/Admin/System/GetRoleList", //获取角色列表
	AddRole: "/api/Admin/System/AddRole", //新增角色
	UpdataRole: "/api/Admin/System/UpdataRole", //编辑角色
	DeleteRole: "/api/Admin/System/DeleteRole", //删除角色

	//基础设置
	GetDictionaryList: "/api/Admin/BasicSetting/GetDictionaryList", //获取数据字典列表
	AddDictionary: "/api/Admin/BasicSetting/AddDictionary", //新增数据字典
	UpdateDictionary: "/api/Admin/BasicSetting/UpdateDictionary", //编辑数据字典
	DeleteDictionary: "/api/Admin/BasicSetting/DeleteDictionary", //删除数据字典
	GetProductList: "/api/Admin/BasicSetting/GetProductList", //获取商品信息列表
	AddProduct: "/api/Admin/BasicSetting/AddProduct", //新增商品信息
	UpdateProduct: "/api/Admin/BasicSetting/UpdateProduct", //编辑商品信息
	DeleteProduct: "/api/Admin/BasicSetting/DeleteProduct", //删除商品信息
	GetInfomercialList: "/api/Admin/BasicSetting/GetInfomercialList", //获取广告信息列表
	AddInfomercialInfo: "/api/Admin/BasicSetting/AddInfomercialInfo", //新增广告信息
	UpdateInfomercialInfo: "/api/Admin/BasicSetting/UpdateInfomercialInfo", //编辑广告信息
	DeleteInfomercialInfo: "/api/Admin/BasicSetting/DeleteInfomercialInfo", //删除广告信息
	GetRaffleInfoList: "/api/Admin/BasicSetting/GetRaffleInfoList", //获取抽奖信息列表
	BatchAddRaffleInfo: "/api/Admin/BasicSetting/BatchAddRaffleInfo", //新增抽奖信息
	BatchUpdateRaffleInfo: "/api/Admin/BasicSetting/BatchUpdateRaffleInfo", //修改抽奖信息
	BatchDeleteRaffleInfo: "/api/Admin/BasicSetting/BatchDeleteRaffleInfo", //删除抽奖信息

	//权益管理
	GetBenefitsItemList: "/api/Admin/Benefits/GetBenefitsItemList", //获取权益项列表
	AddBenefitsItem: "/api/Admin/Benefits/AddBenefitsItem", //新增权益项信息
	UpdateBenefitsItem: "/api/Admin/Benefits/UpdateBenefitsItem", //编辑权益项信息
	DeleteBenefitsItem: "/api/Admin/Benefits/DeleteBenefitsItem", //删除权益项信息
	GetBenefitsInfoList: "/api/Admin/Benefits/GetBenefitsInfoList", //获取权益信息列表
	AddBenefitsInfo: "/api/Admin/Benefits/AddBenefitsInfo", //新增权益信息
	UpdateBenefitsInfo: "/api/Admin/Benefits/UpdateBenefitsInfo", //编辑权益信息
	DeleteBenefitsInfo: "/api/Admin/Benefits/DeleteBenefitsInfo", //删除权益信息
	GetBenefitsProductList: "/api/Admin/Benefits/GetBenefitsProductList", //获取权益商品列表
	AddBenefitsProduct: "/api/Admin/Benefits/AddBenefitsProduct", //新增权益商品
	UpdateBenefitsProduct: "/api/Admin/Benefits/UpdateBenefitsProduct", //编辑权益商品
	DeleteBenefitsProduct: "/api/Admin/Benefits/DeleteBenefitsProduct", //删除权益商品

	//证书管理
	GetCertificateTypeList: "/api/Admin/Certificate/GetCertificateTypeList", //获取证书类型列表
	AddCertificateType: "/api/Admin/Certificate/AddCertificateType", //新增证书类型
	UpdateCertificateType: "/api/Admin/Certificate/UpdateCertificateType", //编辑证书类型
	DeleteCertificateType: "/api/Admin/Certificate/DeleteCertificateType", //删除证书类型
	GetCertificateInfoList: "/api/Admin/Certificate/GetCertificateInfoList", //获取证书信息列表

	//日程管理
	GetScheduleInfoList: "/api/Admin/Schedule/GetScheduleInfoList", //获取日程信息列表
	AddCertificateInfo: "/api/Admin/Certificate/AddCertificateInfo", //新增证书信息
	UpdatedCertificateInfo: "/api/Admin/Certificate/UpdatedCertificateInfo", //编辑证书信息
	DeleteCertificateInfo: "/api/Admin/Certificate/DeleteCertificateInfo", //删除证书信息

	//小程序端
	GetAppletUserList: "/api/Admin/Applet/GetUserList", //获取会员列表
	GetPrivacyInfo: "/api/Admin/Applet/GetPrivacyInfo", //获取小程序隐私协议内容
	SavePrivacyInfo: "/api/Admin/Applet/SavePrivacyInfo", //保存小程序隐私协议信息

	//消息推送
	GetMessagePushList: "/api/Admin/MessagePush/GetMessagePushList", //获取消息推送记录列表
	GetMessagePushSettingsList: "/api/Admin/MessagePush/GetMessagePushSettingsList", //获取消息推送设置列表
	AddMessagePushSettingsInfo: "/api/Admin/MessagePush/AddMessagePushSettingsInfo", //新增消息推送设置
	UpdateMessagePushSettingsInfo: "/api/Admin/MessagePush/UpdateMessagePushSettingsInfo", //编辑消息推送设置
	DeleteMessagePushSettings: "/api/Admin/MessagePush/DeleteMessagePushSettings", //删除消息推送设置信息
	GetScheduleTaskList: "/api/Admin/MessagePush/GetScheduleTaskList", //获取证书日程任务列表

	//订单管理
	GetOrderList: "/api/Admin/Order/GetOrderList", //获取订单列表
	PayReturnOrder: "/api/Admin/Order/PayReturnOrder", //订单退款

	//招商推广管理
	GetEducationStageList: "/api/Admin/Enroll/GetEducationStageList", //获取升学阶段列表
	AddEducationStage: "/api/Admin/Enroll/AddEducationStage", //新增升学阶段
	UpdataEducationStage: "/api/Admin/Enroll/UpdataEducationStage", //编辑升学阶段
	DeleteEducationStage: "/api/Admin/Enroll/DeleteEducationStage", //获取升学阶段列表

	GetSchoolInfoList: "/api/Admin/Enroll/GetSchoolInfoList", //获取学校信息列表
	AddSchoolInfo: "/api/Admin/Enroll/AddSchoolInfo", //新增学校信息
	UpdataSchoolInfo: "/api/Admin/Enroll/UpdataSchoolInfo", //编辑学校信息
	DeleteSchoolInfo: "/api/Admin/Enroll/DeleteSchoolInfo", //删除学校信息

	GetSchoolMajorInfoList: "/api/Admin/Enroll/GetSchoolMajorInfoList", //获取学校专业列表
	AddSchoolMajorInfo: "/api/Admin/Enroll/AddSchoolMajorInfo", //新增学校专业
	UpdataSchoolMajorInfo: "/api/Admin/Enroll/UpdataSchoolMajorInfo", //编辑学校专业
	DeleteSchoolMajorInfo: "/api/Admin/Enroll/DeleteSchoolMajorInfo", //删除学校专业


	GetEnrollPersonnelList: "/api/Admin/Enroll/GetEnrollPersonnelList", //获取推广人员列表
	AddEnrollPersonnel: "/api/Admin/Enroll/AddEnrollPersonnel", //新增推广人员
	UpdataEnrollPersonnel: "/api/Admin/Enroll/UpdataEnrollPersonnel", //编辑推广人员
	DeleteEnrollPersonnel: "/api/Admin/Enroll/DeleteEnrollPersonnel", //删除推广人员
	GetEnrollPersonnelRecordList: "/api/Admin/Enroll/GetEnrollPersonnelRecordList", //获取推广记录列表


}

export {
	Interface
}